export default __webpack_public_path__ + "static/media/ColonialPenn.1b0abe8e.png";